export enum CeilingsTypeTabName {
  MountingType = '1',
  LightingType = '2',
}

export const MOUNTING_TYPE_GALLERY_NAME_LIST = [
  'mounting-type-section.gapless.title',
  'mounting-type-section.shadow.title',
  'mounting-type-section.shadow.title',
  'mounting-type-section.shadow.title',
  'mounting-type-section.gapless.title',
  'mounting-type-section.shadow.title',
  'mounting-type-section.gapless.title',
  'mounting-type-section.shadow.title',
  'mounting-type-section.gapless.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.gapless.title',
  'mounting-type-section.gapless.title',
  'mounting-type-section.gapless.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.gapless.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.shadow.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.gapless.title',
  'mounting-type-section.shadow.title',
  'mounting-type-section.gapless.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.gapless.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.shadow.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.shadow.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.gapless.title',
  'mounting-type-section.gapless.title',
  'mounting-type-section.shadow.title',
  'mounting-type-section.shadow.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.shadow.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.two-level.title',
  'mounting-type-section.shadow.title',
];

export const LIGHTING_TYPE_GALLERY_NAME_LIST = [
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.illumination-canvas.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.floating.title',
  'lighting-type-section.figured-lines.title',
  'lighting-type-section.figured-lines.title',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.contour-lighting.title',
  'lighting-type-section.floating.title',
  'lighting-type-section.floating.title',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.figured-lines.title',
  'lighting-type-section.floating.title',
  'lighting-type-section.floating.title',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.contour-lighting.title',
  'lighting-type-section.figured-lines.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.illumination-canvas.title',
  'lighting-type-section.contour-lighting.title',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.floating.title',
  'lighting-type-section.figured-lines.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.illumination-canvas.title',
  'lighting-type-section.contour-lighting.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.illumination-canvas.title',
  'lighting-type-section.figured-lines.title',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.floating.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.contour-lighting.title',
  'lighting-type-section.figured-lines.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.figured-lines.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.floating.title',
  'lighting-type-section.contour-lighting.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.floating.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.floating.title',
  'lighting-type-section.figured-lines.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.contour-lighting.title',
  'lighting-type-section.floating.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.figured-lines.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.contour-lighting.title',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.figured-lines.title',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.illumination-canvas.title',
  'lighting-type-section.illumination-canvas.title',
  'lighting-type-section.floating.title',
  'lighting-type-section.figured-lines.title',
  'lighting-type-section.recessed-lamps.name',
  'lighting-type-section.contour-lighting.title',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.contour-lighting.title',
  'lighting-type-section.floating.title',
  'lighting-type-section.light-lines.title',
  'lighting-type-section.figured-lines.title',
  'lighting-type-section.recessed-lamps.name',
];
